import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Card from "../../../components/Card";
import Logo from "../../../assets/images/kiashaa-logo.png";
import { AuthAPI } from "../../../js/api";
import { handleApiError } from "../../../js/helper/errorHandler";

const SignIn = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    if (!formData.email.trim() || !formData.password.trim()) {
      toast.error("Please enter both email and password.");
      return;
    }

    setLoading(true);

    try {
      const response = await AuthAPI.login(formData);
      const res = response.data;

      // SUCCESS
      if (res.status === 200 || res.status === "success") {
        const admin = res.data;
        localStorage.setItem("authorization", admin.authorization);

        toast.success("Login successful!");

        setTimeout(() => navigate("/dashboard"), 500);

        return;
      }
      toast.error(res.message || "Login failed");
    } catch (error) {
      handleApiError(error, "Unable to login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login-content">
        <Row className="m-0 align-items-center justify-content-center bg-white vh-100">
          <Col md="4">
            <Card className="d-flex justify-content-center mb-0 bg-dark-green p-4">
              <Card.Body>
                <div className="text-center mb-4">
                  <img src={Logo} alt="Logo" width={200} />
                </div>
                <h4 className="mb-2 text-center text-white">Sign In</h4>

                <Form>
                  <Form.Group className="form-group">
                    <Form.Label className="text-white">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email"
                    />
                  </Form.Group>
                  <Form.Group className="form-group">
                    <Form.Label className="text-white">Password</Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder="Password"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleLogin();
                      }}
                    />
                  </Form.Group>
                  <Form.Check className="form-check mb-3">
                    <Form.Check.Input
                      type="checkbox"
                      onChange={() => setShowPassword(!showPassword)}
                    />
                    <Form.Check.Label className="text-white">
                      Show Password
                    </Form.Check.Label>
                  </Form.Check>

                  <div className="d-flex justify-content-center mt-3">
                    <button
                      onClick={handleLogin}
                      type="button"
                      className="btn-theme"
                    >
                      {loading ? "Signing In..." : "Sign In"}
                    </button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </section>
      <div className="footer-body justify-content-center mt-2 mb-2 text-center">
        <p
          style={{ fontSize: "14px", color: "#000", fontWeight: "500" }}
          className="m-0"
        >
          This is a private internal admin tool for managing owned Etsy shops
          only.
        </p>
      </div>
    </>
  );
};

export default SignIn;
